import axios from "axios";
import Auth from "./auth.service";
import Cookies from "js-cookie";

class Common {
  getUserType = async () => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/user-types`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getTransactionType = async () => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/transaction-types`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getTransactionTypeCharge = async (
    sender_user_type_id,
    receiver_user_type_id
  ) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/transaction-types?for=charge&sender_user_type_id=${sender_user_type_id}&receiver_user_type_id=${receiver_user_type_id}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getTransactionTypeCashBack = async (
    sender_user_type_id,
    receiver_user_type_id
  ) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/transaction-types?for=cashback&sender_user_type_id=${sender_user_type_id}&receiver_user_type_id=${receiver_user_type_id}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getTransactionTypeLimit = async (sender_user_type_id) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/transaction-types?for=limit&sender_user_type_id=${sender_user_type_id}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getTransactionTypeReward = async (
    sender_user_type_id,
    receiver_user_type_id
  ) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/transaction-types?for=reward&sender_user_type_id=${sender_user_type_id}&receiver_user_type_id=${receiver_user_type_id}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getAccountType = async () => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/account-types`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getLimitType = async () => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/limit-types`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getAllLevel = async () => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/all/levels`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getCurrencies = async () => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/currencies`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      // console.log('taka', res.data)
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getLevel = async (user_type_id) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/levels?user_type_id=${user_type_id}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getMerchantList = async (mobile_no) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/merchants?q=${""}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getAccounts = async () => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/level-wise-account/accounts`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getSelectedAccounts = async (type) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/level-wise-account/accounts?type=${type}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getLimitList = async (
    page,
    userType,
    level,
    limit,
    transactionType,
    status
  ) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/limit-lists?page=${page}&user_type=${userType}&level=${level}&limit=${limit}&transaction_type=${transactionType}&status=${status}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getLevelWiseAccountList = async (
    page,
    level,
    userType,
    account_no,
    created_by,
    updated_by,
    status
  ) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/level-wise-accounts?page=${page}&level_id=${level}&type=${userType}&account_no=${account_no}&created_by=${created_by}&updated_by=${updated_by}&status=${status}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  updatelevelWiseAccount = async (levelWiseID) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/level-wise-account/update-status`,
        levelWiseID,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getCashBackList = async (
    page,
    sender,
    receiver,
    transactionType,
    fromAmount,
    toAmount,
    sender_level,
    receiver_level,
    status
  ) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/cashback?page=${page}&sender=${sender}&receiver=${receiver}&transaction_type=${transactionType}&from_amount=${fromAmount}&to_amount=${toAmount}&sender_level=${sender_level}&receiver_level=${receiver_level}&status=${status}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getRewardsList = async (
    page,
    sender,
    receiver,
    transactionType,
    fromAmount,
    toAmount,
    sender_level,
    receiver_level,
    status
  ) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");

      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/rewards?page=${page}&sender=${sender}&receiver=${receiver}&transaction_type=${transactionType}&from_amount=${fromAmount}&to_amount=${toAmount}&sender_level=${sender_level}&receiver_level=${receiver_level}&status=${status}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  updateCashBack = async (CashBackID) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/cashback/update-status`,
        CashBackID,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  updateRewards = async (RewardId) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/reward/update-status`,
        RewardId,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  createReward = async (rewardInfo) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/reward`,
        rewardInfo,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  createCashBack = async (cashBackInfo) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/cashback`,
        cashBackInfo,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getChargeList = async (
    page,
    sender,
    receiver,
    merchant,
    transactionType,
    fromAmount,
    toAmount,
    sender_level,
    receiver_level,
    status
  ) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/charges?page=${page}&sender=${sender}&receiver=${receiver}&merchant=${encodeURIComponent(
          merchant
        )}&transaction_type=${transactionType}&from_amount=${fromAmount}&to_amount=${toAmount}&sender_level=${sender_level}&receiver_level=${receiver_level}&status=${status}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  createCharge = async (chargeInfo) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/charge`,
        chargeInfo,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  updateCharge = async (chargeID) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/charge/update-status`,
        chargeID,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  updateLimit = async (limitID) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/limit/update-status`,
        limitID,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  createLimit = async (limitInfo) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/limit`,
        limitInfo,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };


  createLimitPerTransaction = async (limitInfo) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/limit-per-transaction`,
        limitInfo,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  updateLimitPerTransaction = async (limitID) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/limit-per-transaction/update-status`,
        limitID,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  getLimitPerTransactionList = async (
    page,
    userType,
    level,
    transactionType,
    status
  ) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const res = await axios.get(
        `${Auth.getHost()}api/v1/com-panel/limit-per-transaction-lists?page=${page}&user_type=${userType}&level=${level}&transaction_type=${transactionType}&status=${status}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  createLevel = async (info) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/level/create`,
        info,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  deleteLevel = async (info) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/level/delete`,
        info,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  updateLevel = async (info) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/level/update`,
        info,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  createLevelWiseAccount = async (levelWiseAccountInfo, testGet) => {
    // return console.log("data", levelWiseAccountInfo);
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/level-wise-account`,
        levelWiseAccountInfo,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      // console.log("error", error.response.status);
      // return setErrorMsgBody('something is wrong')

      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  changeUserPassword = async (userPassInfo) => {
    try {
      const accessToken = Cookies.getJSON("fast_pay_acc");
      const loginResponse = await axios.post(
        `${Auth.getHost()}api/v1/com-panel/change-password`,
        userPassInfo,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      return loginResponse.data;
    } catch (error) {
      if (error.response.status === 401) {
        setTimeout(() => {
          Cookies.remove("fast_pay_acc");
          Cookies.remove("user");
          localStorage.clear();
          window.location.reload();
        }, 2000);
      }
    }
  };

  userSignOut = async () => {
    const accessToken = Cookies.getJSON("fast_pay_acc");
    const loginResponse = await axios.post(
      `${Auth.getHost()}api/v1/auth/logout`,
      {},

      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );
    return loginResponse.data;
  };
}

export default new Common();
